export const BANNER_VARIANTS = {
  PRIMARY: 'primary',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};
//# sourceMappingURL=consts.js.map